function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
/** Allows clients to register listeners which are called using trigger. */ export var EventChannel = /*#__PURE__*/ function() {
    "use strict";
    function EventChannel() {
        _classCallCheck(this, EventChannel);
        this.listeners = [];
    }
    _createClass(EventChannel, [
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.listeners.push(callback);
                return this.unsubscribe.bind(this, callback);
            }
        },
        {
            key: "trigger",
            value: function trigger(data) {
                this.listeners.forEach(function(listener) {
                    return listener(data);
                });
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.listeners = [];
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.listeners = this.listeners.filter(function(listener) {
                    return listener !== callback;
                });
            }
        }
    ]);
    return EventChannel;
}();
